<h1 class="title my-4 text-center">Remove Two-Factor Authentication</h1>

<div class="text-center" *ngIf="checking">
  Verifying your link...
</div>

<ng-container *ngIf="!checking && !reverted && !linkInvalid">
  <p class="text-center">
    Two-factor authentication was recently added to
    <strong *ngIf="email">{{email}}</strong><ng-container *ngIf="!email">your account</ng-container>
    <ng-container *ngIf="phoneNumber"> using <strong>{{phoneNumber}}</strong></ng-container>.
  </p>
  <p class="text-center">
    If this wasn't you, remove it now. Your active sessions will be signed out.
  </p>
  <div class="text-center">
    <button
      type="button"
      class="btn btn-danger btn-block btn-lg ut-revert-btn"
      [disabled]="requestInProgress"
      (click)="revert()">
      Remove Second Factor
    </button>
    <!-- Not a routerLink: a live session belongs on the dashboard, and ExistingSessionGuard
         cannot make that call here (see backToLogin). The success and error views below
         keep their plain links - applying the code revokes the session. -->
    <button
      type="button"
      class="btn btn-link ut-back-to-login"
      [disabled]="leaving"
      (click)="backToLogin()">
      Back to Login
    </button>
    <div class="alert alert-danger mt-3 ut-leave-error" *ngIf="leaveErrorMsg">{{leaveErrorMsg}}</div>
  </div>
</ng-container>

<div class="alert alert-success text-center ut-revert-success" *ngIf="reverted">
  <strong>The second factor has been removed from your account.</strong>
  <hr />
  <div>
    If you did not add it yourself, someone else may know your password.
    We strongly recommend resetting it now.
  </div>
  <a routerLink="../forgot-password" class="btn btn-link">Reset Password</a>
  <a routerLink="../login" class="btn btn-link">Back to Login</a>
</div>

<div class="alert alert-danger text-center" *ngIf="errorMsg && errorMsg.length > 0">
  <strong>{{errorMsg}}</strong>
  <hr />
  <div>If you believe someone else has access to your account, reset your password immediately.</div>
  <a routerLink="../forgot-password" class="btn btn-link">Reset Password</a>
</div>
